import React from "react";

const AdminDashboard = () => {
  return (
    <div>
      <h2>Admin Dashboard</h2>
    </div>
  );
};

export default AdminDashboard;